import * as React from 'react';
import { isEmpty } from 'lodash';
import styles from './CartItemCardPriceInfo.css';
import StringWidget from 'components/StringWidget/StringWidget';
import { OfferSymbol } from 'components/PriceSummary/PriceLineItem';
import cx from 'classnames';
import { PriceType } from '@rome/response/transact/PriceType';
import { numFormat } from 'utils/numFormat';
import { stringTemplate } from 'components/StringWidget/StringWidget';
export function ReversePrice(props) {
    const { detail } = props;
    if (isEmpty(detail))
        return null;
    const value = detail.value || 0;
    if (!value)
        return null;
    const isStrikeOff = detail.strikeOff === true;
    const classname = cx(styles['price'], {
        [styles['non-strikeoff-price']]: !isStrikeOff,
        [styles['strike-off-price']]: isStrikeOff
    });
    return (<span className={classname}>
			{OfferSymbol.Minus} ₹{numFormat(value)}
		</span>);
}
export function Price(props) {
    const { detail, isEmphasized, showZeroValPrice = false } = props;
    if (isEmpty(detail))
        return null;
    const value = detail.value || 0;
    if (!value && !showZeroValPrice) {
        return <span className={styles['free-pricing']}>{stringTemplate('free')}</span>;
    }
    const isStrikeOff = detail.strikeOff === true;
    const classname = cx(styles['price'], {
        [styles['non-strikeoff-price']]: !isStrikeOff,
        [styles['strike-off-price']]: isStrikeOff,
        [styles['emphasized']]: isEmphasized
    });
    return <span className={classname}>₹{numFormat(value)}</span>;
}
export function Discount(props) {
    const { detail } = props;
    if (isEmpty(detail))
        return null;
    const value = detail.value || 0;
    if (!value)
        return null;
    const classname = cx(styles['price'], styles['discount-price']);
    return (<StringWidget strKey="cartRsDiscount" className={classname} attributes={{ discountAmount: numFormat(value) }}/>);
}
export function DiscountPercent(props) {
    const { detail } = props;
    if (isEmpty(detail))
        return null;
    const value = detail.value || 0;
    if (!value)
        return null;
    return (<StringWidget strKey="cartDiscount" className={styles['discount-percent']} attributes={{ discountPercent: value }}/>);
}
function SavingAmount(props) {
    const { detail } = props;
    if (isEmpty(detail))
        return null;
    const value = detail.value || 0;
    if (!value)
        return null;
    const priceString = numFormat(value);
    return (<StringWidget strKey="grocerySaving" className={styles['discount-percent']} attributes={{ amount: priceString }}/>);
}
export function CartItemCardPriceInfo(props) {
    const { details, className, isEmphasized, showZeroValPrice = false } = props;
    if (isEmpty(details) || isEmpty(details.prices))
        return null;
    const { prices = [] } = details;
    const children = prices.map((priceObj, index) => {
        const priceType = priceObj.priceType || '';
        switch (priceType) {
            case PriceType.PRICE:
                return <Price detail={priceObj} key={index} isEmphasized={isEmphasized} showZeroValPrice={showZeroValPrice}/>;
            case PriceType.REVERSE:
                return <ReversePrice detail={priceObj} key={index}/>;
            case PriceType.DISCOUNT:
                return <Discount detail={priceObj} key={index}/>;
            case PriceType.DISCOUNT_PERCENT:
                return <DiscountPercent detail={priceObj} key={index}/>;
            case PriceType.SAVING_AMOUNT:
                return <SavingAmount detail={priceObj} key={index}/>;
            default:
                return null;
        }
    });
    if (className) {
        return <div className={className}>{children}</div>;
    }
    return <React.Fragment>{children}</React.Fragment>;
}
